import React, { ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Caught by ErrorBoundary:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      const token = localStorage.getItem('token');
      const userString = atob(token?.split('.')[1] || '');
      const user = JSON.parse(userString);
      const userId = user.user;

      return (
        <div
          style={{
            padding: '1rem',
            fontFamily: 'sans-serif',
            color: '#b00020',
          }}
        >
          <h2>Something went wrong.</h2>
          <p>Displaying userId for reporting:</p>
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              background: '#f8f8f8',
              padding: '0.5rem',
            }}
          >
            {userId || 'User ID not found'}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
